import { TileLayer } from "leaflet";
import { GridLayer, withLeaflet } from "react-leaflet";
import { CachedTileLayer } from "components/OverviewPages/Map/tileLayer.cached";
import PropTypes from "prop-types";

class LTileColorFilter extends CachedTileLayer {
  constructor(url, options) {
    options.useCache = true;
    options.saveToCache = true;
    super(url, options);
    this._container = null;
  }

  initialize(url, options) {
    options.useCache = true;
    options.saveToCache = true;
    super.initialize(url, options);
  }

  // noinspection JSUnusedGlobalSymbols
  _initContainer() {
    TileLayer.prototype._initContainer.call(this);
    this._container.style.filter = this.colorFilter();
  }

  updateFilter(newFilter) {
    this.options.filter = newFilter;
    if (this._container) {
      this._container.style.filter = this.colorFilter();
    }
  }

  colorFilter() {
    const VALIDFILTERS = [
      "blur:px",
      "brightness:%",
      "bright:brightness:%",
      "bri:brightness:%",
      "contrast:%",
      "con:contrast:%",
      "grayscale:%",
      "gray:grayscale:%",
      "hue-rotate:deg",
      "hue:hue-rotate:deg",
      "hue-rotation:hue-rotate:deg",
      "invert:%",
      "inv:invert:%",
      "opacity:%",
      "op:opacity:%",
      "saturate:%",
      "saturation:saturate:%",
      "sat:saturate:%",
      "sepia:%",
      "sep:sepia:%"
    ];

    const colorFilterOptions = this.options.filter ? this.options.filter : [];
    return colorFilterOptions
      .map(opt => {
        const filter = opt.toLowerCase().split(":");
        if (filter.length === 2) {
          let match = VALIDFILTERS.find(vf => vf.split(":")[0] === filter[0]);
          if (match) {
            match = match.split(":");
            filter[1] += /^\d+$/.test(filter[1]) ? match[match.length - 1] : "";
            return `${match[match.length - 2]}(${filter[1]})`;
          }
        }
        return "";
      })
      .filter(x => x)
      .join(" ");
  }
}

class ColorFilter extends GridLayer {
  static propTypes = {
    filter: PropTypes.arrayOf(PropTypes.string)
  };

  createLeafletElement(props) {
    return new LTileColorFilter(props.url, super.getOptions(props));
  }
}

const ColorFilterWithLeaflet = withLeaflet(ColorFilter);

export { ColorFilterWithLeaflet as ColorFilter, LTileColorFilter };
